import get from 'lodash/get';

export default (element, result) => {
  const { values, options } = element.properties;
  const defaultValues = values || options;
  if (!result) {
    return defaultValues;
  }
  const sortedValues = get(result, 'elementsOrder', [])
    .filter((item) => item.id === element.id)
    .map((item) => item.order)
    .shift();
  return sortedValues || defaultValues;
};
